import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import { Link } from '../../routes';
import Img from './Img';

const ServiceTypeItem = ({ name, icon, path, services }) => (
  <div className="service-list__item col-12 col-sm-6 col-md-4 col-lg-3" data-aos="fade-up" data-aos-delay="30" data-aos-duration="500">
    <Link to={path}>
      <a>
        <div className="service-list__item--icons">
          <LazyLoad once>
            <Img
              src={icon}
              alt={name}
            />
          </LazyLoad>
          <strong className="caps">{name}</strong>
        </div>
      </a>
    </Link>
    <ul className="navs">
      {services.map(service => (
        <li key={service.id}>
          <Link to={service.path}><a>{service.title}</a></Link>
        </li>
      ))}
    </ul>
  </div>
);

ServiceTypeItem.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  services: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    path: PropTypes.string,
  })).isRequired,
};

export default ServiceTypeItem;
